import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=10f55900&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=10f55900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../pws_portal/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f55900",
  null
  
)

export default component.exports